import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { LoginService } from 'src/app/managers/login.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { RssFeedService } from 'src/app/managers/rssFeed.service';
import { Channel } from 'src/app/models/channel';
import { ChannelItem } from 'src/app/models/channel_item';
import { Category } from 'src/app/models/category';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { OrderBy } from 'src/app/repositories/base.repository';
import { OutputDataService } from 'src/app/common/services/output-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent extends BaseComponent implements OnChanges, OnInit, OnDestroy {
  @Input() addedFavoriteChannelItem: ChannelItem;
  @Input() removedFavoriteChannelItem: ChannelItem;
  @Input() isSignIn: boolean;
  categoryLoading: boolean;
  categories: Category[];
  favChannel: Channel;
  favoriteItemCount: number;
  private _onLogoutSubscription: Subscription;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _rssFeedManager: RssFeedService,
              private _snackBar: MatSnackBar, private _outputDataSrv: OutputDataService) { 
    super(route, loginManager, clientConfig, dialog);
    this.categoryLoading = false;
    this.categories = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'addedFavoriteChannelItem') {
        //let change: SimpleChange = changes[propName];
        this.favoriteItemCount += 1;
      }
      else if (propName === 'removedFavoriteChannelItem') {
        this.favoriteItemCount -= 1;
      }
    }
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.parentComponent === 'home') {
      this.loadAllDataAsync();
    }

    this._onLogoutSubscription = this._outputDataSrv.onLogout.subscribe(() => {
      this.loadAllDataAsync();
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._onLogoutSubscription.unsubscribe();
  }

  private async loadAllDataAsync() {
    let responseMsg: CoreResponseMessage;
    
    this.categoryLoading = true;
    this.favoriteItemCount = 0;
    this.categories = [];
    responseMsg = await this._rssFeedManager.getCategoriesAllAsync(this.getLoggedinUser(), 0, 0, 'Name', OrderBy.ASC.toString());

    if (responseMsg.Status === CoreResponseStatus.OK) {
      let favCategories: Category[] = responseMsg.Result.filter(c => c.Name === 'bookmarks');

      if (this.isUserLogged()) {
        this.favChannel = favCategories[0].Channels[0];
        this.favoriteItemCount = Number(this.favChannel.ChannelUrl);
      } 
      else
        this.favoriteItemCount = 0;     

      this.categories = responseMsg.Result.filter(c => c.Name !== 'bookmarks');
    }
    else {
      this.favChannel = this.createEmptyFavoriteChannel();
      this.favoriteItemCount = 0;

      if (responseMsg.Status !== CoreResponseStatus.NoData) {
        this._snackBar.open('Failed to load subscriptions: ' + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
        this.handleCoreResponseMessageError(responseMsg);
      }
    }

    this.categoryLoading = false;
  }

  private createEmptyFavoriteChannel(): Channel {
    return { Id: 0, UserId: 0, ChannelUrl: '0', Title: 'Favorite_Builtin', Categories: null, PublishDate: null, ImageUrl: '', Active: false,
             Show: false, ModifiedDate: null, CreatedDate: null };
  }
}
